export type LeatStore = {
  uuid: string
  name: string
  type: string
}

// store_integration_settings is a shared table keyed per-partner by column
// prefix (lightspeed_*, leat_*), not a Leat-specific relation.
export type LeatStoreLink = {
  id: string
  store_integration_settings: {
    leat_store_id: string | null
    leat_order_push_enabled: boolean | null
  }
}

// TODO(author): confirm SLERP with BE — only the LEAT value is attested.
export enum LoyaltyImplementation {
  SLERP = 'SLERP',
  LEAT = 'LEAT'
}

export interface ConnectStoresRow {
  storeId: string
  leatStoreId: string | null
  leatOrderPushEnabled: boolean
}
